export default __webpack_public_path__ + "static/media/home.ccc12840.svg";